<script>

    import Login from '../components/login.svelte'
    import Register from '../components/register.svelte'


    let offset = false;

    let callback = () => {
        offset = !offset;
    }
    console.log("Sup boi")

</script>


<section>
    {#if !offset}
    <Login callback={callback}/>

    {:else}
    <Register callback={callback}/>
    {/if}



</section>

<style>
    section {
        height: 100%;
    }
</style>